
import { supabase } from "@/integrations/supabase/client";
import { ScoreboardState, UpdateScoreboardState } from "@/types/scoreboard";

export async function getKitId(kitNumber: string) {
  const { data, error } = await supabase
    .from('kits')
    .select('id')
    .eq('number', parseInt(kitNumber))
    .maybeSingle();

  if (error) throw error;
  if (!data) throw new Error('Kit not found');
  return data;
}

export async function getScoreboardState(kitId: string) {
  const { data, error } = await supabase
    .from('scoreboard_states')
    .select('*')
    .eq('kit_id', kitId)
    .maybeSingle();

  if (error) throw error;
  
  if (!data) {
    // Create new state if none exists
    const { data: newState, error: createError } = await supabase
      .from('scoreboard_states')
      .insert({ kit_id: kitId })
      .select()
      .single();

    if (createError) throw createError;
    return newState;
  }

  return data;
}

export async function updateScoreboardState(kitId: string, state: UpdateScoreboardState) {
  const { data, error } = await supabase
    .from('scoreboard_states')
    .update(state)
    .eq('kit_id', kitId)
    .select()
    .single();

  if (error) throw error;
  return data;
}
